import { client } from './client';
import { EnumValueData } from '../models/enum';

export const getEnumValues = async (enumTypeName: string): Promise<EnumValueData[]> => {
  const { data } = await client.get<EnumValueData[]>(`/common/enums/${enumTypeName}`);
  return data;
};

